import { Icon, Button, Popover, Text } from '@southfields-digital/mxmz-react-ui';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import RundownOutputDialog from 'src/components/RundownOutputDialog';
import useAuth from 'src/hooks/useAuth';
import { usePlayerVersion } from 'src/hooks/usePlayerVersion';
import { StateType } from 'src/redux/reducers';
import { hasLegacyPlayer } from 'src/utils/playerVersion';

import ShortKeysDialog from '../ShortKeysDialog';

import { RundownLayoutToggles } from './RundownLayoutToggles';
import styles from './RundownSettings.module.scss';
import { useRundownLayout } from './useRundownLayout';

export default function RundownSettings() {
  const { data: rundown } = useSelector((state: StateType) => state.rundown.detail);
  const [showRundownOutputs, setShowRundownOutputs] = useState(false);
  const [showShortKeys, setShowShortKeys] = useState(false);

  const auth = useAuth();
  const isBetaUser = auth.isBetaUser();
  const { isLegacy, setLegacy } = usePlayerVersion();

  // Use the new layout hook
  useRundownLayout();

  return (
    <div className={styles.Container}>
      <Popover className={styles.Popover} position="right">
        <Popover.Button className={styles.PopoverButton}>
          <Icon icon="cog" weight="regular" size={24}></Icon>
        </Popover.Button>
        <Popover.Panel className={styles.Panel}>
          {({ close }) => (
            <ul className={styles.Content}>
              <li>
                <Button
                  as="a"
                  to={`/rundowns/edit/${rundown?.id}`}
                  iconProps={{ size: 24, icon: 'exit-link', weight: 'regular' }}
                  variant="tertiary"
                  className={styles.Button}
                >
                  <Text as="span">Edit rundown</Text>
                </Button>
              </li>
              <li>
                <Button
                  as="button"
                  iconProps={{ size: 24, icon: 'browser', weight: 'regular' }}
                  variant="tertiary"
                  onClick={() => {
                    setShowRundownOutputs(true);
                    close();
                  }}
                  className={styles.Button}
                >
                  <Text as="span">Configure outputs</Text>
                </Button>
              </li>

              <RundownLayoutToggles
                onClose={close}
                filterLayouts={({ beta }) => {
                  if (beta) return isBetaUser;
                  return true;
                }}
              />

              <li>
                <Button
                  as="button"
                  iconProps={{ size: 24, icon: 'info', weight: 'regular' }}
                  variant="tertiary"
                  onClick={() => {
                    setShowShortKeys(true);
                    close();
                  }}
                  className={styles.Button}
                >
                  <Text as="span">View shortkeys</Text>
                </Button>
              </li>

              {isBetaUser && hasLegacyPlayer ? (
                <li>
                  <Button
                    as="button"
                    iconProps={{ size: 24, icon: 'monitor-play', weight: 'regular' }}
                    variant="tertiary"
                    onClick={() => {
                      setLegacy(!isLegacy);
                      close();
                    }}
                    className={styles.Button}
                  >
                    <Text as="span">{isLegacy ? 'Use player-v2' : 'Use player-v1 (legacy)'}</Text>
                  </Button>
                </li>
              ) : null}
            </ul>
          )}
        </Popover.Panel>
      </Popover>
      <RundownOutputDialog show={showRundownOutputs} onClose={() => setShowRundownOutputs(false)} />
      <ShortKeysDialog isOpen={showShortKeys} onClose={() => setShowShortKeys(false)} />
    </div>
  );
}
